export type CuentaCorriente = {
    id: number,
    parcialDebe: number,
    parcialHaber: number,
    saldo: number,
    personaId: string,
    personaNombre: string,
    personaNumDocumento: string,
}

export enum CuentaCorrienteItemTipo {
    Miscelaneo,
    Cliente,
    Vendedor,
    Proveedor,
}

export type CuentaCorrienteItem = {
    id: number,
    tipo: CuentaCorrienteItemTipo,
    fecha: string,
    descripcion: string,
    debe: number,
    haber: number,
    saldo: number
}